// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2UD1B","subheader":"ReorderModal_subheader__1tHSU","listWrap":"ReorderModal_listWrap__3wS12"};